<template>
    <div class='main'>
        <h1 class='title'>ご注文ありがとうございました</h1>
        <p>ご入力頂いたメールアドレス宛にご注文内容を送信しました</p>
        <p>ご注文内容はマイページからも確認ができます</p>
        <button class='button is-primary is-fullwidth' @click='toMypage'>マイページへ</button>
    </div>
</template>

<script>

export default {
    name: 'complete',
    components: {
    },
    data () {
        return {
        }
    },
    mounted () {
    },
    methods: {
        toMypage () {
            this.$router.push('/photobuy/mypage')
        }
    }
}
</script>

<style scoped>

.main {
    max-width: 1280px;
    min-height: calc(100vh - 80px);
    margin: auto;
    padding: 20px;
}

h1 {
    margin-top: 120px;
    font-size: 25px;
}

.button {
    margin-top: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/photobuy/pages/Complete.vue